import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Link from "@tiptap/extension-link";
import { useEffect, useMemo } from "react";
import { safelyParseJSON } from "helpers/common";

// Optional: sanitizer to strip invalid nodes
const sanitizeTiptapDoc = (doc) => {
  if (!doc || doc.type !== "doc") return { type: "doc", content: [] };

  return {
    ...doc,
    content: (doc.content || []).filter((node) => typeof node?.type === "string"),
  };
};

const TiptapViewer = ({ content }) => {
  // Parse & normalize the content safely
  const parsed = useMemo(() => {
    const safe = safelyParseJSON(content);
    const doc = safe?.json || safe || "";
    return typeof doc === "object" ? sanitizeTiptapDoc(doc) : doc;
  }, [content]);

  const editor = useEditor({
    extensions: [
      StarterKit,
      TextStyle,
      Color,
      Link.configure({
        openOnClick: true,
        linkOnPaste: false,
        autolink: false,
      }),
    ],
    content: parsed,
    editable: false,
  });

  useEffect(() => {
    if (editor && parsed) {
      try {
        editor.commands.setContent(parsed);
      } catch (e) {
        console.warn("[TiptapViewer] Failed to set content:", e);
      }
    }
  }, [parsed, editor]);

  if (!editor) return null;

  return <div className="tiptap-message">
    <EditorContent editor={editor} />
  </div>;
};

export default TiptapViewer;
